import { render, staticRenderFns } from "./WhiteCardQuery.vue?vue&type=template&id=2291ce4c&scoped=true"
import script from "./WhiteCardQuery.vue?vue&type=script&lang=js"
export * from "./WhiteCardQuery.vue?vue&type=script&lang=js"
import style0 from "./WhiteCardQuery.vue?vue&type=style&index=0&id=2291ce4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2291ce4c",
  null
  
)

export default component.exports